export const HAPTTIC_WEB = 'https://hapttic.com/coming-soon'
